import React, { Component } from 'react';
// import PortaleFilterWidgetLink from '../PortaleFilterWidgetLink';
import PortaleWidgetLink from '../PortaleWidgetLink';

export default class WidgetStatistichePortale extends Component {
    render() {

        return (
            <div className="widget">
                <h2 className="pb-2">Statistiche portale</h2>
                <div className="row">
                    <div className="col-12">
                        <PortaleWidgetLink
                            to="/statistichePortale"
                            icon="fas fa-archive"
                            // portaleId={portaleId}
                        >
                            Statistiche mail
                        </PortaleWidgetLink>
                    </div>
                    <div className="col-12">
                        <PortaleWidgetLink
                            to="/portaliArchivioMail"
                            icon="fas fa-chart-line"
                            // portaleId={portaleId}
                        >
                            Archivio mail
                        </PortaleWidgetLink>
                    </div>
                </div>
            </div>
        );
    }
}
